import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DICE_RENEWALS_CONFIG } from 'src/app/_common/product-config';
import { HeaderData } from 'src/app/_models/header-data';
import { RenewalsService } from '../../_services/renewals.service';
import { DiceRenewalBindStatus, RenewalBindPolicyStatus } from 'src/app/_common/_enum/module.enum';

@Component({
  selector: 'app-bind-confirmation',
  templateUrl: './bind-confirmation.component.html',
  styleUrls: ['./bind-confirmation.component.scss']
})
export class BindConfirmationComponent implements OnInit {
  private headerData: HeaderData;

  private bannerMsgs = DICE_RENEWALS_CONFIG.BannerMessages;
  private bindStatusEnum = DiceRenewalBindStatus;
  private bindPolicyStatusEnum = RenewalBindPolicyStatus;
  private bindStatus: any = this.bindStatusEnum.SUBMITTED;
  private renewalNumber;
  private isPrimaryLineDeclined: boolean = false;
  private isOfflineError: boolean = false;

  @Input() bindResponse: any;
  constructor(public readonly route: ActivatedRoute, private readonly router: Router, private renewalService: RenewalsService) { }

  ngOnInit() {
    /* Setting Headers Starts */
      this.headerData = new HeaderData();
      this.setHeaderData();
    /* Setting Headers Ended */
    console.log('In Confirmaiton : ', this.bindResponse);

    //Getting Renewal Number for State params
    this.route.paramMap.subscribe(params => {
      this.renewalNumber = params.get("id").toString();
    });
  }

  setHeaderData(){
    this.headerData.pageTitle = "Bind Request Submitted";

    this.renewalService.header = this.headerData;
    this.headerData.breadcrumb = [{itemName: "← Back to Manage Renewal", itemLink: "../renewals/"+ this.bindResponse.renewalNumber+"/"+this.bindResponse.accountNumber +"/manage"}];
    this.setBindStatus();
  }

  setBindStatus() {
    this.isPrimaryLineDeclined = this.bindResponse.renewingPolicies.some(_policy => (_policy.status.toLowerCase() === this.bindPolicyStatusEnum.OfflineProcessPLDNR.toLowerCase()));
    this.isOfflineError = this.bindResponse.renewingPolicies.every(_policy => (_policy.status.toLowerCase() === this.bindPolicyStatusEnum.OfflineProcessBindProcessError.toLowerCase() || _policy.status.toLowerCase() === this.bindPolicyStatusEnum.OfflineProcessRateApiError.toLowerCase()));
  }
}